export default __webpack_public_path__ + "static/media/FP_FR_F.4f2a269b.png";